(ns ui.dom-globals
  (:require [common.util :as cu]
            [oops.core :as oops]
            [ui.security.sanitize :as san]))

(defn body
  []
  js/document.body)

(defn location
  []
  js/document.location)

(defn set-location!
  [path]
  (set! js/location.href path))

(defn element-by-id
  [id]
  (js/document.getElementById id))

(defn create-element
  [tag-name]
  (js/document.createElement tag-name))

(defn append-to-body
  [element]
  (.appendChild (body) element))

(defn remove-element
  [element]
  (.remove element))

(defn set-style!
  [element property value]
  (when element
    (let [style (.-style ^js element)]
      (.setProperty style property value))))

(defn elements-by-class
  [class]
  (js/document.getElementsByClassName class))

(defn query-selector
  [element q]
  (.querySelector element q))

(defn get-attribute
  [element a]
  (.getAttribute element a))

(defn number-format
  []
  (oops/oget js/Intl "NumberFormat"))

(defn dom-value
  [o]
  (.-value o))

(defn dom-select
  [o]
  (.select o))

(defn set-selection
  [o start end]
  (.setSelectionRange o start end))

(defn target
  [e]
  (.-target e))

(defn current-target
  [e]
  (.-currentTarget e))

(defn event-target-value
  [e]
  (-> e
      (.-target)
      (.-value)))

(defn event-target-checked?
  [e]
  (-> e
      (.-target)
      (.-checked)))

(defn ag-grid-selected-rows
  [event]
  (-> event
      (oops/oget "api")
      (oops/ocall! "getSelectedRows")))

(defn ag-grid-server-side-selection-state
  "The selection state of an AG Grid with the server-side row model, or nil for
   a grid that has another row model."
  [event]
  (let [api (oops/oget event "api")]
    (when (oops/oget+ api "getServerSideSelectionState")
      (oops/ocall! api "getServerSideSelectionState"))))

(defn event-key
  [e]
  (.-key e))

(defn escape-key?-handler
  [event callback]
  (when (and (= "Escape" (event-key event))
             (fn? callback))
    (callback)))

(defn escape-key-handler
  [event callback]
  (escape-key?-handler event callback))

(defn event-key-code
  [e]
  (.-keyCode e))

(defn event-meta-key
  [e]
  (.-metaKey e))

(defn event-shift-key
  [e]
  (.-shiftKey e))

(defn prevent-default
  [e]
  (.preventDefault e)
  e)

(defn stop-propagation
  [e]
  (.stopPropagation e)
  e)

(defn prevent-and-stop
  [e]
  (-> e
      (prevent-default)
      (stop-propagation)))

(defn persist-event
  [e]
  (.persist e)
  e)

(defn event-transfer-files
  [e]
  (-> e
      .-dataTransfer
      .-files))

(defn data-transfer
  [e]
  (.-dataTransfer e))

(defn data-transfer-set-data
  [dt mime value]
  (.setData dt mime value))

(defn data-transfer-set-effect-allowed
  [dt value]
  (set! (.-effectAllowed dt) value))

(defn event-target-files
  [e]
  (-> e
      .-target
      .-files))

(defn date->millis
  [dt]
  (when dt
    (.getTime dt)))

(defn date->timezone-offset
  [dt]
  (.getTimezoneOffset dt))

(defn open-window
  [url]
  (.open js/window url))

(defn set-timeout!
  [callback delay-ms]
  (js/setTimeout callback delay-ms))

(defn clear-timeout!
  [handle]
  (js/clearTimeout handle))

(defn download-file
  [url]
  (when-let [sanitized (san/sanitize-url url)]
    (.open js/window sanitized "_blank")))

(defn history-back
  []
  (.back js/window.history))

(defn date-get-month
  [dt]
  (.getMonth dt))

(defn date-get-full-year
  [dt]
  (.getFullYear dt))

(defn has-tag-name-in-dom-path [node tag-names]
  (if-not node
    false
    (let [tag-name (-> node
                       .-tagName
                       (cu/str-trim-lcase))
          match? (some #{tag-name} tag-names)]
      (or match?
          (has-tag-name-in-dom-path (-> node .-parentElement) tag-names)))))

(defn offset-top
  [element]
  (when element
    (-> element
        (.-offsetTop))))

(defn offset-left
  [element]
  (when element
    (-> element
        (.-offsetLeft))))

(defn offset-width
  [element]
  (when element
    (.-offsetWidth element)))

(defn offset-height
  [element]
  (when element
    (.-offsetHeight element)))

(defn client-width
  [element]
  (when element
    (.-clientWidth element)))

(defn bounding-client-rect
  [element]
  (when element
    (.getBoundingClientRect element)))

(defn rect-top
  [rect]
  (when rect
    (.-top rect)))

(defn rect-bottom
  [rect]
  (when rect
    (.-bottom rect)))

(defn window-inner-height
  []
  (.-innerHeight js/window))

(defn client-y
  [mouse-event]
  (.-clientY mouse-event))

(defn scroll-left
  [element]
  (when element
    (.-scrollLeft element)))

(defn scroll-top
  [element]
  (when element
    (.-scrollTop element)))

(defn scroll-width
  [element]
  (when element
    (.-scrollWidth element)))

(defn client-x
  [mouse-event]
  (.-clientX mouse-event))

(defn abort-controller
  []
  (js/AbortController.))

(defn event-target-scroll-top
  [e]
  (-> e
      .-currentTarget
      .-scrollTop))

(defn parent-node
  [node]
  (.-parentElement node))

(defn remove-child
  [node child]
  (.removeChild node child))

(defn blur!
  [node]
  (when node
    (.blur node)))

(defn focus!
  [node]
  (when node
    (.focus node)))

(defn hidden?
  [node]
  (.-hidden node))

(defn client-height
  [node]
  (when node
    (.-clientHeight node)))

(defn scroll-height
  [node]
  (when node
    (.-scrollHeight node)))

(defn find-parent-with-class [node cls]
  (when node
    (let [parent (-> node .-parentElement)
          has-class? (some-> parent
                             .-classList
                             (.contains cls))]
      (if (or (nil? parent) has-class?)
        parent
        (find-parent-with-class parent cls)))))

(defn node-contains?
  [node child]
  (when node
    (.contains node child)))

(defn add-event-listener!
  [target event-name handler]
  (.addEventListener target event-name handler))

(defn remove-event-listener!
  [target event-name handler]
  (.removeEventListener target event-name handler))

(defn set-value!
  [input-elem value]
  (set! (.-value input-elem) (str value)))

(defn start-index
  [js-obj]
  (.-startIndex js-obj))

(defn end-index
  [js-obj]
  (.-endIndex js-obj))
